import { Flex } from "@fluentui/react-northstar";
import React from "react";

import { CONTAINER_CLASS } from "../../../shared/styleConstants";
import { ConnectedResultsDeviceStatusCard } from "../results-device-status-card/ConnectedResultsDeviceStatusCard";
import { ConnectedResultsHeader } from "../results-header/ConnectedResultsHeader";
import { ConnectedStartAudioTestButton } from "../results-start-audio-test-button/ConnectedStartAudioTestButton";
import { ConnectedResultsSidePanel } from "../results-side-panel/ConnectedResultsSidePanel";
import { ConnectedResultsFinishTestButton } from "../results-finish-test-button/ConnectedResultsFinishTestButton";
import { ConnectedDesktopPermissionPrompt } from "../results-desktop-permission-request/ConnectedDesktopPermissionPrompt";
import { ConnectedDeviceStatusDialogBox } from "../results-device-status-dialog-box/ConnectedDeviceStatusDialogBox";
import { ConnectedResultsDesktopAudioTestModal } from "../results-desktop-audio-test-modal/ConnectedResultsDesktopAudioTestModal";
import { ConnectedPrivacyFooter } from "../../privacy-footer/ConnectedPrivacyFooter";
import { ConnectedPermissionDeniedPopup } from "../../permission-denied-dialog/ConnectedPermissionDeniedPopup";

import { useResultsViewStyles } from "./ResultsView.styles";
import { ResultsViewProps } from "./ResultsView.types";

// Results page for desktop and mobile devices
export const ResultsView: React.FC<ResultsViewProps> = ({ isMobile }) => {
  const resultsViewStyles = useResultsViewStyles();

  if (isMobile) {
    return (
      <Flex>
        <ConnectedDeviceStatusDialogBox />
        <ConnectedPermissionDeniedPopup />
        <Flex
          className={CONTAINER_CLASS}
          data-testid="resultsPage"
          styles={resultsViewStyles.container}
          fill
          column
          gap="gap.large"
        >
          <Flex.Item size="size.half">
            <Flex hAlign="center" vAlign="end">
              <ConnectedResultsHeader />
            </Flex>
          </Flex.Item>

          <Flex.Item size="size.half">
            <Flex column vAlign="end" padding="padding.medium">
              <Flex hAlign="center" padding="padding.medium">
                <ConnectedResultsDeviceStatusCard />
              </Flex>
              <Flex hAlign="end" padding="padding.medium">
                <ConnectedStartAudioTestButton />
              </Flex>
            </Flex>
          </Flex.Item>

          <Flex.Item>
            <Flex
              column
              hAlign="center"
              vAlign="center"
              padding="padding.medium"
            >
              <ConnectedResultsFinishTestButton />
            </Flex>
          </Flex.Item>

          <Flex.Item>
            <Flex hAlign="center" vAlign="end" padding="padding.medium">
              <ConnectedPrivacyFooter />
            </Flex>
          </Flex.Item>
        </Flex>
      </Flex>
    );
  } else {
    return (
      <Flex fill>
        <ConnectedDeviceStatusDialogBox />
        <ConnectedResultsDesktopAudioTestModal />
        <ConnectedDesktopPermissionPrompt />
        <Flex
          className={CONTAINER_CLASS}
          data-testid="resultsPage"
          styles={resultsViewStyles.container}
          column
          fill
          gap="gap.medium"
        >
          <Flex.Item size="size.quarter">
            <Flex hAlign="center" vAlign="end">
              <ConnectedResultsHeader />
            </Flex>
          </Flex.Item>

          <Flex.Item size="size.half">
            <Flex hAlign="center" vAlign="center" gap="gap.small">
              <ConnectedResultsDeviceStatusCard />
            </Flex>
          </Flex.Item>

          <Flex.Item>
            <Flex column vAlign="start" hAlign="center" gap="gap.large">
              <Flex gap="gap.small" hAlign="center">
                <ConnectedStartAudioTestButton />
                <ConnectedResultsSidePanel />
              </Flex>
              <Flex gap="gap.large" padding="padding.medium">
                <ConnectedResultsFinishTestButton />
              </Flex>
            </Flex>
          </Flex.Item>

          <Flex.Item push>
            <Flex hAlign="center" vAlign="end" padding="padding.medium">
              <ConnectedPrivacyFooter />
            </Flex>
          </Flex.Item>
        </Flex>
      </Flex>
    );
  }
};
